(() => {
  const gate = document.getElementById('ImportConfirmationGate');

  if (!gate) return;

  const ATTRIBUTE_SERVICE = '輸入確認申請代行';
  const ATTRIBUTE_SYSTEM_ID = '医薬品等輸入確認情報システムID';
  const checkoutSelector = 'button[name="checkout"], input[name="checkout"]';
  const form = gate.querySelector('[data-import-confirmation-form]');
  const emailInput = gate.querySelector('input[type="email"]');
  const confirmationInput = gate.querySelector('input[name="confirmed"]');
  const submitButton = gate.querySelector('[data-import-confirmation-submit]');
  const errorMessage = gate.querySelector('[data-import-confirmation-error]');
  const bypassButtons = new WeakMap();
  let checkoutButton = null;
  let processingCheckout = false;

  function assistanceVariantIds() {
    const ids = new Set(
      (gate.dataset.assistanceVariantIds || '')
        .split(',')
        .map((id) => Number(id.trim()))
        .filter(Boolean)
    );
    const configElement = document.getElementById('mwFeesConfigData');

    if (!configElement) return ids;

    try {
      const config = JSON.parse(configElement.textContent);

      (config.fees || []).forEach((fee) => {
        if (!String(fee.title || '').includes('輸入確認')) return;

        (fee.options || []).forEach((option) => {
          if (String(option.title || '').includes('申請代行を利用する') && option.variant_id) {
            ids.add(Number(option.variant_id));
          }
        });
      });
    } catch (error) {
      console.warn('輸入確認申請代行のUpCharge設定を読み取れませんでした。', error);
    }

    return ids;
  }

  function noAssistanceVariantIds() {
    const ids = new Set([48642823291120, 48644716626160]);
    const configElement = document.getElementById('mwFeesConfigData');

    if (!configElement) return ids;

    try {
      const config = JSON.parse(configElement.textContent);

      (config.fees || []).forEach((fee) => {
        if (!String(fee.title || '').includes('輸入確認')) return;

        (fee.options || []).forEach((option) => {
          if (String(option.title || '').includes('申請しない') && option.variant_id) {
            ids.add(Number(option.variant_id));
          }
        });
      });
    } catch (error) {
      console.warn('輸入確認申請なしのUpCharge設定を読み取れませんでした。', error);
    }

    return ids;
  }

  async function getCart() {
    const response = await fetch(gate.dataset.cartUrl, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);

    return response.json();
  }

  function usesApplicationAssistance(cart) {
    const ids = assistanceVariantIds();

    return (cart.items || []).some((item) => {
      if (ids.has(Number(item.variant_id || item.id))) return true;

      const properties = JSON.stringify(item.properties || {});
      return [...ids].some((id) => properties.includes(String(id)));
    });
  }

  function usesNoApplicationAssistance(cart) {
    const ids = noAssistanceVariantIds();
    return (cart.items || []).some((item) => ids.has(Number(item.variant_id || item.id)));
  }

  function cartFromPage() {
    const cartElement = document.getElementById('mwFeesCart');

    if (!cartElement) return null;

    try {
      return JSON.parse(cartElement.textContent);
    } catch (error) {
      console.warn('画面内のUpChargeカート情報を読み取れませんでした。', error);
      return null;
    }
  }

  function assistanceIsSelectedOnPage() {
    const ids = assistanceVariantIds();

    return [...document.querySelectorAll('.mw-fee__control[type="radio"]:checked')].some((input) =>
      ids.has(Number(input.value))
    );
  }

  function uncheckedTermsCheckbox() {
    return [...document.querySelectorAll('.rterms-checkbox')].find(
      (input) => input instanceof HTMLInputElement && input.offsetParent !== null && !input.checked
    );
  }

  function requireTermsAcceptance(event) {
    const checkbox = uncheckedTermsCheckbox();
    if (!checkbox) return true;

    event?.preventDefault();
    event?.stopImmediatePropagation();
    window.alert('「重要事項の説明」を確認し、同意にチェックを入れてください。');
    checkbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
    checkbox.focus({ preventScroll: true });
    return false;
  }

  async function waitForApplicationAssistance() {
    const attempts = 15;

    for (let attempt = 0; attempt < attempts; attempt += 1) {
      const cart = await getCart();
      if (usesApplicationAssistance(cart)) return cart;
      await new Promise((resolve) => window.setTimeout(resolve, 200));
    }

    throw new Error('Application assistance was not added to the cart in time.');
  }

  async function updateAttributes(attributes) {
    const response = await fetch(gate.dataset.cartUpdateUrl, {
      method: 'POST',
      credentials: 'same-origin',
      keepalive: true,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ attributes }),
    });

    if (!response.ok) throw new Error(`Cart update failed: ${response.status}`);

    return response.json();
  }

  function showError(message) {
    errorMessage.textContent = message;
    errorMessage.hidden = false;
  }

  function clearError() {
    errorMessage.textContent = '';
    errorMessage.hidden = true;
  }

  function openGate() {
    clearError();
    confirmationInput.checked = false;
    gate.hidden = false;
    document.body.classList.add('import-confirmation-gate-open');
    window.setTimeout(() => emailInput.focus(), 0);
  }

  function closeGate() {
    gate.hidden = true;
    document.body.classList.remove('import-confirmation-gate-open');
    checkoutButton?.focus();
  }

  function continueCheckout() {
    const button = checkoutButton;
    checkoutButton = null;
    processingCheckout = false;

    if (!button || !document.contains(button)) {
      openGate();
      showError('購入手続きボタンを確認できませんでした。カートページを再読み込みしてください。');
      return;
    }

    bypassButtons.set(button, Date.now() + 10000);
    button.click();
  }

  async function prepareCheckout(button) {
    if (processingCheckout) return;

    processingCheckout = true;
    checkoutButton = button;
    button.setAttribute('aria-busy', 'true');

    try {
      const pageCart = cartFromPage();

      if ((pageCart && usesApplicationAssistance(pageCart)) || assistanceIsSelectedOnPage()) {
        const savedEmail = pageCart?.attributes?.[ATTRIBUTE_SYSTEM_ID];
        if (savedEmail) emailInput.value = savedEmail;
        processingCheckout = false;
        openGate();
        return;
      }

      const cart = await getCart();

      if (usesApplicationAssistance(cart)) {
        const savedEmail = cart.attributes?.[ATTRIBUTE_SYSTEM_ID];
        if (savedEmail) emailInput.value = savedEmail;
        processingCheckout = false;
        openGate();
        return;
      }

      const hasStaleData = cart.attributes?.[ATTRIBUTE_SERVICE] || cart.attributes?.[ATTRIBUTE_SYSTEM_ID];
      if (hasStaleData) {
        await updateAttributes({
          [ATTRIBUTE_SERVICE]: null,
          [ATTRIBUTE_SYSTEM_ID]: null,
        });
      }

      continueCheckout();
    } catch (error) {
      console.error(error);
      processingCheckout = false;
      window.alert('カート情報を確認できませんでした。通信環境を確認して、もう一度お試しください。');
    } finally {
      button.removeAttribute('aria-busy');
    }
  }

  window.addEventListener(
    'click',
    (event) => {
      const button = event.target instanceof Element ? event.target.closest(checkoutSelector) : null;

      if (!button || button.closest('#ImportConfirmationGate')) return;
      if (!requireTermsAcceptance(event)) return;

      const bypassUntil = bypassButtons.get(button) || 0;
      if (Date.now() < bypassUntil) {
        return;
      }
      bypassButtons.delete(button);

      const pageCart = cartFromPage();
      if (pageCart && !usesApplicationAssistance(pageCart) && !assistanceIsSelectedOnPage()) {
        const hasStaleData = pageCart.attributes?.[ATTRIBUTE_SERVICE] || pageCart.attributes?.[ATTRIBUTE_SYSTEM_ID];
        if (usesNoApplicationAssistance(pageCart) && hasStaleData) {
          event.preventDefault();
          event.stopImmediatePropagation();
          prepareCheckout(button);
        }
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      prepareCheckout(button);
    },
    true
  );

  gate.querySelectorAll('[data-import-confirmation-close]').forEach((button) => {
    button.addEventListener('click', closeGate);
  });

  gate.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeGate();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusableElements = [...gate.querySelectorAll('button:not([disabled]), input:not([disabled])')];
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  });

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    clearError();
    emailInput.value = emailInput.value.trim();

    if (!form.reportValidity()) return;

    submitButton.disabled = true;
    submitButton.setAttribute('aria-busy', 'true');

    try {
      await waitForApplicationAssistance();
      await updateAttributes({
        [ATTRIBUTE_SERVICE]: '利用する',
        [ATTRIBUTE_SYSTEM_ID]: emailInput.value,
      });
      closeGate();
      continueCheckout();
    } catch (error) {
      console.error(error);
      showError('入力内容を保存できませんでした。通信環境を確認して、もう一度お試しください。');
    } finally {
      submitButton.disabled = false;
      submitButton.removeAttribute('aria-busy');
    }
  });
})();
